const CURRENT_DOMAIN = `${window.location.protocol}//${window.location.host}`;

const LOGIN_REDIRECT = "/auth/callback/cognito";
const LOGOUT_REDIRECT = "/auth/callback/cognito/logout";

export function getLoginRedirect(prefix = "") {
  return `${CURRENT_DOMAIN}${prefix}${LOGIN_REDIRECT}`;
}

export function getLogoutRedirect(prefix = "") {
  return `${CURRENT_DOMAIN}${prefix}${LOGOUT_REDIRECT}`;
}

// Expiry times must apparently be hardcoded. In seconds.

export const TOKEN_EXPIRY_TIME = 3 * 60; // 3 minutes. It's actually 5 but I saw one spurious refresh and want to be safe.
export const REFRESH_TOKEN_EXPIRY_TIME = 24 * 60 * 60; // 24 hours

// Store session data before redirecting to Cognito
export const SESSION_KEY_RECENT_TENANT = "rana_session_key_recent_tenant";
export const SESSION_KEY_RECENT_IDENTITY_PROVIDER = "rana_session_key_recent_identity_provider";
export const SESSION_KEY_RECENT_PATH = "rana_session_key_recent_path";

// If an account has no access to a tenant anymore they will automatically be logged out in the tenant provider.
// When we do that we hang the ACCOUNT_HAS_NO_ACCESS_SESSION_KEY into the session storage with value true.
// When the logout cognito comes back to the callback page. We see if that key is in the session storage
// and if it is we add the query params ACCOUNT_HAS_NO_ACCESS_SEARCH_PARAM to the logged out page \
// so it can show a message about the account having no access.
export const ACCOUNT_HAS_NO_ACCESS_SESSION_KEY = "rana_account_has_no_access";
export const ACCOUNT_HAS_NO_ACCESS_SEARCH_PARAM = "noAccess";

// Set when a user accepts an invitation via a cross-tenant identity provider
// (an IdP that is not configured for the inviting tenant). This prevents
// useInvitationAccept from storing the foreign IdP in localStorage, which
// would cause infinite redirect loops on future visits to the tenant.
export const CROSS_TENANT_INVITATION_SESSION_KEY = "rana_cross_tenant_invitation";
